import React, { Component } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title, ChartOptions } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

function ConsumptionOverview(props: any) {

	ChartJS.register(ArcElement, Tooltip, Legend, Title);

	const datapoints = [props.greenEnergy, props.unsold];

	// Plugin to show dounut chart middle text
	const counter = {
		id: "counter",
		beforeDraw(chart: any, args: any, option: any) {
			const { ctx, chartArea: { top, right, bottom, left, width, height } } = chart;
			ctx.save();

			//Calculate Green energey precentage;
			let sum = parseFloat(datapoints[0]) + parseFloat(datapoints[1]);
			let percentage = (parseFloat(datapoints[0]) * 100 / sum).toFixed(2) + "%" == "100.00%" ? "100%" : (parseFloat(datapoints[0]) * 100 / sum).toFixed(2) + "%";

			ctx.font = "700 1.75rem Montserrat";
			ctx.textAlign = "center"
			ctx.fillText((sum == 0  ? "0%" : percentage), width / 2, top + 10 + (height / 2));

			ctx.font = "400 0.5rem Montserrat";
			ctx.textAlign = "center"
			ctx.fillText('Green attributes sold', width / 2, top + 20 + (height / 2));
		}
	}
	const chartDataDoughnut = {
		labels: ['24/7 CFE (kWh) ', 'Unsold (kWh) '],
		backgroundColor: '#f5f5f5',
		datasets: [
			{
				label: '# of Votes',
				data: datapoints,
				backgroundColor: [
					'#006837',
					'#e16838',

				],
				borderColor: [
					'#006837',
					'#e16838',
					
				],
				borderWidth: 1,
				borderRadius: 0,
			},
		]
	};

	const chartOptionsDoughnut: ChartOptions<'doughnut'> = {
		responsive: true,
		maintainAspectRatio: false,
		plugins: {
			legend: {
				display: false,
				position: 'right',
				labels: {
					usePointStyle: true,
					padding: 20,
					textAlign: 'left',
					font: {
						size: 16,
						family: 'Montserrat',
					}
				},
			},
		}
	};

	return (
		<div><Doughnut data={chartDataDoughnut} options={chartOptionsDoughnut} plugins={[counter]} className="consumptionOverview" /></div>
		// <div><Doughnut data={chartDataDoughnut} /></div>
	)

}
export default ConsumptionOverview;